export const translations = {
  en: {
    translation: {
      // Navigation
      nav: {
        home: "Home",
        shop: "Shop",
        about: "About",
        cart: "Cart",
        wishlist: "Wishlist",
        admin: "Admin"
      },
      // Hero
      hero: {
        title: "FIGHT LIKE A GYAL",
        subtitle: "Self-defense is your right. Be prepared. Be empowered.",
        cta: "Shop Now",
        marquee: "LET FEAR CHANGE SIDES • NO MORE SILENCE • SELF DEFENSE IS A RIGHT • FIGHT BACK"
      },
      // Shop
      shop: {
        title: "Our Arsenal",
        all: "All",
        tasers: "Stun Guns",
        alarms: "Alarms",
        hammers: "Window Breakers",
        sprays: "Sprays",
        kubatons: "Kubatons",
        accessories: "Accessories",
        packs: "Packs",
        addToCart: "Add to Cart",
        addToWishlist: "Add to Wishlist",
        removeFromWishlist: "Remove from Wishlist",
        outOfStock: "Out of Stock",
        selectColor: "Select Color",
        viewDetails: "View Details"
      },
      // Cart
      cart: {
        title: "Your Cart",
        empty: "Your cart is empty",
        total: "Total",
        checkout: "Checkout",
        remove: "Remove",
        quantity: "Qty",
        continueShopping: "Continue Shopping"
      },
      // Wishlist
      wishlist: {
        title: "Your Wishlist",
        empty: "Your wishlist is empty",
        moveToCart: "Move to Cart"
      },
      // Checkout
      checkout: {
        title: "Checkout",
        shipping: "Shipping Information",
        fullName: "Full Name",
        email: "Email",
        address: "Address",
        addressLine2: "Address Line 2 (Optional)",
        city: "City",
        postalCode: "Postal Code",
        country: "Country",
        payWithPaypal: "Pay with PayPal",
        processing: "Processing...",
        orderSummary: "Order Summary",
        orderComplete: "Order Complete!",
        thankYou: "Thank you for your purchase. You will receive a confirmation email shortly.",
        backToShop: "Back to Shop"
      },
      // Product
      product: {
        description: "Description",
        price: "Price",
        colors: "Available Colors",
        inStock: "In Stock",
        outOfStock: "Out of Stock"
      },
      // Admin
      admin: {
        dashboard: "Dashboard",
        products: "Products",
        orders: "Orders",
        totalProducts: "Total Products",
        totalOrders: "Total Orders",
        pendingOrders: "Pending Orders",
        revenue: "Revenue",
        addProduct: "Add Product",
        editProduct: "Edit Product",
        deleteProduct: "Delete Product",
        orderStatus: "Order Status",
        updateStatus: "Update Status"
      },
      // Footer
      footer: {
        rights: "Your right to defend yourself.",
        tagline: "Let fear change sides.",
        disclaimer: "Check local laws before purchasing self-defense products. Products are sold for legitimate self-defense purposes only.",
        legal: "Legal Notice",
        legalNotice: "Legal Information",
        legalFrance: "🇫🇷 France: Contact stun devices are generally Category D (adult sale only). Taser projectiles are more regulated (Category B or not available to public). Carry/transport strictly regulated. Use only in legitimate self-defense (necessity, immediacy, proportionality).",
        paypalProtection: "Shop with confidence. Your purchase is protected by PayPal Buyer Protection."
      },
      // Common
      common: {
        loading: "Loading...",
        error: "Something went wrong",
        success: "Success!",
        cancel: "Cancel",
        save: "Save",
        delete: "Delete",
        edit: "Edit",
        close: "Close"
      }
    }
  },
  es: {
    translation: {
      nav: {
        home: "Inicio",
        shop: "Tienda",
        about: "Nosotras",
        cart: "Carrito",
        wishlist: "Favoritos",
        admin: "Admin"
      },
      hero: {
        title: "FIGHT LIKE A GYAL",
        subtitle: "La defensa personal es tu derecho. Prepárate. Empodérate.",
        cta: "Comprar Ahora",
        marquee: "QUE EL MIEDO CAMBIE DE BANDO • NO MÁS SILENCIO • LA DEFENSA PERSONAL ES UN DERECHO • LUCHA"
      },
      shop: {
        title: "Nuestro Arsenal",
        all: "Todo",
        tasers: "Tasers",
        alarms: "Alarmas",
        hammers: "Rompecristales",
        sprays: "Sprays",
        kubatons: "Kubatons",
        accessories: "Accesorios",
        packs: "Packs",
        addToCart: "Añadir al Carrito",
        addToWishlist: "Añadir a Favoritos",
        removeFromWishlist: "Quitar de Favoritos",
        outOfStock: "Agotado",
        selectColor: "Seleccionar Color",
        viewDetails: "Ver Detalles"
      },
      cart: {
        title: "Tu Carrito",
        empty: "Tu carrito está vacío",
        total: "Total",
        checkout: "Pagar",
        remove: "Eliminar",
        quantity: "Cant",
        continueShopping: "Seguir Comprando"
      },
      wishlist: {
        title: "Tus Favoritos",
        empty: "Tu lista de favoritos está vacía",
        moveToCart: "Mover al Carrito"
      },
      checkout: {
        title: "Pago",
        shipping: "Información de Envío",
        fullName: "Nombre Completo",
        email: "Correo Electrónico",
        address: "Dirección",
        addressLine2: "Línea de Dirección 2 (Opcional)",
        city: "Ciudad",
        postalCode: "Código Postal",
        country: "País",
        payWithPaypal: "Pagar con PayPal",
        processing: "Procesando...",
        orderSummary: "Resumen del Pedido",
        orderComplete: "¡Pedido Completado!",
        thankYou: "Gracias por tu compra. Recibirás un email de confirmación pronto.",
        backToShop: "Volver a la Tienda"
      },
      product: {
        description: "Descripción",
        price: "Precio",
        colors: "Colores Disponibles",
        inStock: "En Stock",
        outOfStock: "Agotado"
      },
      admin: {
        dashboard: "Panel",
        products: "Productos",
        orders: "Pedidos",
        totalProducts: "Total Productos",
        totalOrders: "Total Pedidos",
        pendingOrders: "Pedidos Pendientes",
        revenue: "Ingresos",
        addProduct: "Añadir Producto",
        editProduct: "Editar Producto",
        deleteProduct: "Eliminar Producto",
        orderStatus: "Estado del Pedido",
        updateStatus: "Actualizar Estado"
      },
      footer: {
        rights: "Tu derecho a defenderte.",
        tagline: "Que el miedo cambie de bando.",
        disclaimer: "Consulta las leyes locales antes de comprar productos de defensa personal. Los productos se venden únicamente para fines de legítima defensa.",
        legal: "Aviso Legal",
        legalNotice: "Información Legal",
        legalFrance: "🇫🇷 Francia: Los dispositivos eléctricos de contacto son generalmente Categoría D (venta a mayores de edad). Los taser con proyectiles están más regulados (Categoría B o no accesibles al público). Porte/transporte estrictamente regulado. Uso únicamente en legítima defensa (necesidad, inmediatez, proporcionalidad).",
        paypalProtection: "Compra con confianza. Tu compra está protegida por la Protección al Comprador de PayPal."
      },
      common: {
        loading: "Cargando...",
        error: "Algo salió mal",
        success: "¡Éxito!",
        cancel: "Cancelar",
        save: "Guardar",
        delete: "Eliminar",
        edit: "Editar",
        close: "Cerrar"
      }
    }
  },
  fr: {
    translation: {
      nav: {
        home: "Accueil",
        shop: "Boutique",
        about: "À Propos",
        cart: "Panier",
        wishlist: "Favoris",
        admin: "Admin"
      },
      hero: {
        title: "FIGHT LIKE A GYAL",
        subtitle: "L'autodéfense est votre droit. Soyez préparée. Soyez autonome.",
        cta: "Acheter Maintenant",
        marquee: "QUE LA PEUR CHANGE DE CAMP • PLUS DE SILENCE • L'AUTODÉFENSE EST UN DROIT • RIPOSTEZ"
      },
      shop: {
        title: "Notre Arsenal",
        all: "Tout",
        tasers: "Tasers",
        alarms: "Alarmes",
        hammers: "Brise-Vitres",
        sprays: "Sprays",
        kubatons: "Kubatons",
        accessories: "Accessoires",
        packs: "Packs",
        addToCart: "Ajouter au Panier",
        addToWishlist: "Ajouter aux Favoris",
        removeFromWishlist: "Retirer des Favoris",
        outOfStock: "Épuisé",
        selectColor: "Choisir la Couleur",
        viewDetails: "Voir Détails"
      },
      cart: {
        title: "Votre Panier",
        empty: "Votre panier est vide",
        total: "Total",
        checkout: "Paiement",
        remove: "Supprimer",
        quantity: "Qté",
        continueShopping: "Continuer les Achats"
      },
      wishlist: {
        title: "Vos Favoris",
        empty: "Votre liste de favoris est vide",
        moveToCart: "Ajouter au Panier"
      },
      checkout: {
        title: "Paiement",
        shipping: "Informations de Livraison",
        fullName: "Nom Complet",
        email: "E-mail",
        address: "Adresse",
        addressLine2: "Ligne d'Adresse 2 (Optionnel)",
        city: "Ville",
        postalCode: "Code Postal",
        country: "Pays",
        payWithPaypal: "Payer avec PayPal",
        processing: "Traitement...",
        orderSummary: "Récapitulatif de la Commande",
        orderComplete: "Commande Complète!",
        thankYou: "Merci pour votre achat. Vous recevrez un e-mail de confirmation sous peu.",
        backToShop: "Retour à la Boutique"
      },
      product: {
        description: "Description",
        price: "Prix",
        colors: "Couleurs Disponibles",
        inStock: "En Stock",
        outOfStock: "Épuisé"
      },
      admin: {
        dashboard: "Tableau de Bord",
        products: "Produits",
        orders: "Commandes",
        totalProducts: "Total Produits",
        totalOrders: "Total Commandes",
        pendingOrders: "Commandes en Attente",
        revenue: "Revenus",
        addProduct: "Ajouter Produit",
        editProduct: "Modifier Produit",
        deleteProduct: "Supprimer Produit",
        orderStatus: "Statut de Commande",
        updateStatus: "Mettre à Jour le Statut"
      },
      footer: {
        rights: "Votre droit de vous défendre.",
        tagline: "Que la peur change de camp.",
        disclaimer: "Vérifiez les lois locales avant d'acheter des produits d'autodéfense. Les produits sont vendus uniquement à des fins de légitime défense.",
        legal: "Mentions Légales",
        legalNotice: "Informations Légales",
        legalFrance: "🇫🇷 France: Un dispositif électrique de contact (shocker/taser) est généralement en catégorie D (vente aux majeurs). Un taser à sondes est beaucoup plus encadré (catégorie B ou non accessible au public). Port/transport strictement encadrés. Usage uniquement en légitime défense (nécessité, immédiateté, proportionnalité).",
        paypalProtection: "Achetez en toute confiance. Votre achat est protégé par la Protection des Achats PayPal."
      },
      common: {
        loading: "Chargement...",
        error: "Une erreur est survenue",
        success: "Succès!",
        cancel: "Annuler",
        save: "Sauvegarder",
        delete: "Supprimer",
        edit: "Modifier",
        close: "Fermer"
      }
    }
  }
};
